itsoftApp.createModule("videoIntro", ["windowResize"], function () {
    const module = this;

    const VideoIntro = function () {
        this.names = {
            canPlay: "_can-play",
            playing: "_playing",
            added: "_added",
        };
        this.item = document.querySelector(".video-intro");
        this.bg = document.querySelector('.intro-product__bg');
        this.trigger = document.querySelector(".intro__video-trigger");
        this.videoPreview = this.trigger && this.trigger.querySelector("video");
        this.close = this.item && this.item.querySelector(".video-intro__close");
        this.video = this.item && this.item.querySelector("video");

        /**
         * Значение должно быть равно transition-duration у .video-intro в стилях
         */
        this.transitionDuration = 1000;
        this.delayCheckLoad = 500;

        this.play = false;

        if (this.item && this.trigger) {
            this.init();
        }

        if (!this.trigger && this.item) {
            this.item.style.display = 'none';
        }
    };

    VideoIntro.prototype.init = function () {
        const THIS = this;

        const rect = THIS.getRect();

        THIS.setClipPath(rect);
        THIS.item.style.transitionDuration = "0s";

        THIS.addListeners();

        const debouncedUpdate = itsoftApp.utils.debouncer(function () {
            THIS.onResize();
        }, 300);

        itsoftApp.modules.windowResize.addEvent(function () {
            debouncedUpdate();
        });

        THIS.item.style.display = "none";
    };

    VideoIntro.prototype.addListeners = function () {
        const THIS = this;

        THIS.onKeyDown = THIS.onKeyDown.bind(THIS);

        THIS.trigger.addEventListener("click", THIS.onTriggerClick.bind(THIS));
        THIS.close.addEventListener("click", THIS.onCloseClick.bind(THIS));

        if (!THIS.isMobile()) {
            THIS.trigger.addEventListener("mouseenter", THIS.onTriggerMouseEnter.bind(THIS));
            THIS.trigger.addEventListener("mouseleave", THIS.onTriggerMouseLeave.bind(THIS));
        }
    };

    VideoIntro.prototype.onKeyDown = function (e) {
        const THIS = this;

        if (e.keyCode === 27) {
            document.removeEventListener("keydown", THIS.onKeyDown);
            THIS.onCloseClick();
        }
    };

    VideoIntro.prototype.onTriggerClick = function (e) {
        const THIS = this;

        THIS.item.style.display = "";

        THIS.calcClipPath();

        THIS.play = true;
        THIS.setPadding(`${THIS.getScrollbarSize()}px`);
        THIS.item.classList.add("_active");
        document.body.style.overflow = "hidden";
        THIS.item.style.transitionDuration = "";

        if (!THIS.video.classList.contains(THIS.names.added) && !THIS.video.classList.contains(THIS.names.canPlay)) {
            THIS.video.classList.add(THIS.names.added);
            const source = document.createElement('SOURCE');
            source.src = THIS.video.dataset.src;
            source.type = 'video/mp4';
            THIS.video.appendChild(source);
            THIS.video.load()
            THIS.checkLoad(THIS.video);
        } else {
            THIS.video.play();
        }

        if (window.lennis) {
            window.lennis.stop();
        }
        setTimeout(() => {
            document.addEventListener("keydown", THIS.onKeyDown);
            if (THIS.bg) {
                THIS.bg.style.display = 'none';
            }
        }, THIS.transitionDuration - 500);
    };

    VideoIntro.prototype.onTriggerMouseEnter = function (e) {
        const THIS = this;

        if (THIS.videoPreview.classList.contains("_can-play")) {
            THIS.trigger.classList.add("_active");
            THIS.videoPreview.play();
        }
    };

    VideoIntro.prototype.onTriggerMouseLeave = function (e) {
        const THIS = this;

        THIS.trigger.classList.remove("_active");
        THIS.videoPreview.pause();
        THIS.videoPreview.currentTime = 0;
    };

    VideoIntro.prototype.onCloseClick = function (e) {
        const THIS = this;

        THIS.play = false;
        THIS.item.classList.remove("_active");
        THIS.video.pause();
        if (THIS.bg) {
            THIS.bg.style.display = '';
        }

        setTimeout(() => {
            THIS.item.style.transitionDuration = "0s";
            document.body.style.overflow = "";
            THIS.video.currentTime = 0;
            if (window.lennis) {
                window.lennis.start();
            }
            THIS.setPadding("");
            THIS.item.style.display = "none";
        }, THIS.transitionDuration);
    };

    VideoIntro.prototype.onResize = function (e) {
        const THIS = this;

        THIS.calcClipPath();
    };

    VideoIntro.prototype.setClipPath = function (rect) {
        const THIS = this;

        THIS.item.style.clipPath = `circle(${rect.width / 2}px at ${rect.left + THIS.trigger.clientWidth / 2
            }px ${rect.top + THIS.trigger.clientHeight / 2}px)`;
    };

    VideoIntro.prototype.checkLoad = function (el) {
        const THIS = this;

        if (!el.classList.contains(THIS.names.canPlay) && el.classList.contains(THIS.names.added)) {
            el.classList.add(THIS.names.canPlay);
            el.setAttribute("controlslist", "nodownload");
            if (!el.classList.contains(THIS.names.playing)) {
                THIS.playVideo(el);
            } else {
                setTimeout(() => {
                    if (!el.classList.contains(THIS.names.playing)) {
                        THIS.playVideo(el);
                    }
                }, THIS.delayCheckLoad);
            }
        }
    };

    VideoIntro.prototype.playVideo = function (el) {
        const THIS = this;

        el.classList.add(THIS.names.playing);
        el.play();
    };

    VideoIntro.prototype.getRect = function () {
        const THIS = this;

        return THIS.trigger.getBoundingClientRect();
    };

    VideoIntro.prototype.calcClipPath = function () {
        const THIS = this;

        const rect = THIS.getRect();

        if (!THIS.play) {
            THIS.setClipPath(rect);
        }
    };

    VideoIntro.prototype.setPadding = function (property) {
        const header = document.querySelector(".l-header");
        const disclaimer = document.querySelector(".disclaimer");
        const cookie = document.querySelector(".cookies");

        document.body.style.paddingRight = property;

        if (header) {
            header.style.paddingRight = property;
        }

        if (disclaimer) {
            disclaimer.style.paddingRight = property;
        }

        if (cookie) {
            cookie.style.paddingRight = property;
        }
    };

    VideoIntro.prototype.getScrollbarSize = function () {
        return window.innerWidth - document.body.offsetWidth;
    };

    VideoIntro.prototype.isMobile = function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    new VideoIntro();

    module.callback = VideoIntro;
}
);
